import AddChannelModal from '@components/channelList/modal/AddChannelModal';
import SettingModal from '@components/channelList/modal/SettingModal';
import type { Modal } from '@components/modal/Modal.type';
import useLanguageCodeStore from '@stores/languageCodeStore';
import ErrorModal from '@components/modal/error/ErrorModal';
import LeaveModal from '@components/modal/leave/LeaveModal';
import EditChannelNameModal, { EditChannelNameModalLabel } from '@views/channelSettings/EditChannelNameModal';
import AddMemberModal from '@views/channelSettings/AddMemberModal';

const ModalView = (modal: Modal) => {
  useLanguageCodeStore();

  switch (modal.type) {
    case 'addChannelModal':
      return <AddChannelModal {...modal.props} />;
    case 'settingModal':
      return <SettingModal {...modal.props} />;
    case 'errorModal':
      return <ErrorModal {...modal.props} />;
    case 'leaveModal':
      return <LeaveModal {...modal.props} />;
    case EditChannelNameModalLabel:
      return <EditChannelNameModal {...modal.props} />;
    case 'addMemberModal':
      return <AddMemberModal {...modal.props} />;
    default:
      throw new Error('모달 타입을 제대로 작성해주세요.');
  }
};

export default ModalView;
